import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { selectSystemNotifications } from '@awp/stores/systemNotificationsSlice';

const BellNotification = ({ title }) => {
  const [popoverVisible, setPopoverVisible] = useState(false);
  const systemNotifications = useSelector(selectSystemNotifications);

  if (!systemNotifications || systemNotifications.length == 0) return <></>;

  const closePopover = () => {
    setPopoverVisible(false);
  };

  const notificationPopover = (
    <Popover style={{ minWidth: '30em' }}>
      <Popover.Title as="h4">{title}</Popover.Title>
      <Popover.Content>
        {systemNotifications.map((item, key) => {
          const { pathname, state, text } = item;
          return (
            <div key={key} className="my-2">
              <i className="fas fa-exclamation-circle mx-2 text-bcgold" />
              <Link
                to={pathname}
                state={state}
                onClick={closePopover}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                {text}
              </Link>
            </div>
          );
        })}
      </Popover.Content>
    </Popover>
  );

  return (
    <>
      <div className="notification">
        <OverlayTrigger
          placement="bottom"
          trigger="click"
          rootClose
          overlay={notificationPopover}
          show={popoverVisible}
          onToggle={() => setPopoverVisible(!popoverVisible)}
        >
          <div style={{ cursor: 'pointer' }}>
            <span className="fa-stack fa-1x" data-count={systemNotifications.length}>
              <i className="far fa-bell fa-stack-2x fa-inverse"></i>
            </span>
          </div>
        </OverlayTrigger>
      </div>
    </>
  );
};

export default BellNotification;
